import UpdateAppSystemRequestModelBase from '../_generated/modelBases/update-app-system-request-model-base';

export default class UpdateAppSystemRequestModel extends UpdateAppSystemRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
